<template>
  <div>
    <template v-if="buttonType === 'submit'">
      <button v-on="$listeners" :type="buttonType"
              :class="all_classes"
              class="sm:inline-block block mb-2 sm:mb-0 rounded font-medium cursor-pointer hover:cursor-pointer" tabindex="0">
        <slot></slot>
      </button>
    </template>
    <template v-else>
      <a v-if="!disabled" v-on="$listeners"
         :target="blank ? '_blank' : '_self'"
         :class="all_classes" :href="href"
         class="sm:inline-block block mb-2 sm:mb-0 rounded font-medium cursor-pointer hover:cursor-pointer" tabindex="0">
        <slot></slot>
      </a>
      <button v-else v-on="$listeners"
              :class="all_classes"
              class="sm:inline-block block mb-2 sm:mb-0 rounded font-medium cursor-pointer hover:cursor-pointer" disabled tabindex="0">
        <slot></slot>
      </button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    blank: Boolean,
    href: {
      type: String,
      required: false,
      default: '#'
    },
    colour: {
      type: String,
      required: false,
      default: "blue"
    },
    size: {
      type: String,
      required: false,
      default: "normal"
    },
    buttonType: {
      type: String,
      required: false,
      default: "button"
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    all_classes(){
      return this.sizeClasses()+' '+this.colourClasses();
    },
    is_button(){
      if(this.buttonType === 'submit'){
        return true;
      }

      if(this.disabled){
        return true;
      }

      return false;
    }
  },
  methods: {
    sizeClasses() {
      if (this.size === "small") {
        return 'text-xs px-2 py-1 border-b-2 border-l-1 shadow';
      }

      if (this.size === "medium") {
        return 'text-sm px-3 py-2 border-b-4 border-l-2 shadow-lg';
      }

      return 'text-base px-3 py-2 border-b-4 border-l-2 shadow-lg';
    },
    colourClasses() {
      if (this.colour === "green") {
        return 'bg-green-500 border-green-600 text-white hover:text-white hover:bg-green-400';
      }

      if (this.colour === "red") {
        return 'bg-red-500 border-red-600 text-white hover:text-white hover:bg-red-400';
      }

      if (this.colour === "yellow") {
        return 'bg-yellow-500 border-yellow-600 text-white hover:text-white hover:bg-yellow-400';
      }

      if (this.colour === "white") {
        return 'bg-white border-gray-300 text-gray-600 hover:text-gray-600 hover:bg-gray-100';
      }

      if (this.colour === "gray") {
        return 'bg-gray-500 border-gray-600 text-white hover:text-white hover:bg-gray-400';
      }

      return 'bg-brand border-brand-dark text-white hover:text-white hover:bg-brand-light';
    }
  },
  mounted() {
  }
}
</script>
